<template>
    <div>
      <div style="width: 100%;font-size: 18px;font-weight: 600;text-align: center;background-color: #012D01;color: #ffffff">
        Free shipping international order over $60
      </div>
      <header class="header-area">
      <div class="container-fluid">
        <div class="row">

          <div class="col-md-12">
            <div class="row">
              <div class="col-lg-5 col-md-4 col-sm-3 hidden-xs">
              </div>
              <div class="col-lg-7 col-md-8 col-sm-9">
                <div class="top-right">
                  <div class="top-login-cart">
                    <ul>
                      <li class=" hidden-xs"><router-link to="login">Login or Register</router-link></li>
                      <li class=" hidden-xs"><a href="checkout.html">Checkout</a></li>
                      <li><router-link to="/shopcar"><img src="../assets/img/icon/cart.png" alt="">Cart</router-link>
                        <ul class="submenu-mainmenu">
                          <li class="single-cart-item clearfix" v-for="(item,index) in shopcarList" :key="index">
                                                        <span class="cart-img">
                                                            <a ><img :src="item.imgUrl" alt=""></a>
                                                        </span>
                            <span class="cart-info">
                                                            <a >{{item.name}}</a>
                                                            <span>${{item.price}} x {{item.productCount}}</span>
                                                        </span>
                            <span class="trash-cart">
                                                            <a><i class="fa fa-trash-o"></i></a>
                                                        </span>
                          </li>
                          <li>
                                                        <span class="sub-total-cart text-center">
                                                            Sub Total <span>${{total1}}</span>
                                                            <a  class="view-cart active">View Cart</a>
                                                            <a  class="view-cart">Checkout</a>
                                                        </span>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <div class="search-box">
                    <form action="#">
                      <input type="text" placeholder="Search here...">
                      <button type="submit"><i class="fa fa-search"></i></button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="">
                <div class="mainmenu-area">
                  <nav>
                    <div class="mainmenu" style="display: flex;justify-content: center;align-items: center;margin-bottom: 20px">
                      <ul style="float: left">
                        <li><router-link to='/'>Shop</router-link>
                          <!--<ul class="submenu-mainmenu">-->
                            <!--<li><a href="index-2.html">Home Version 2</a></li>-->
                          <!--</ul>-->
                        </li>
                        <li><a href="about-us.html">Search</a></li>
                        <li><a style="cursor: pointer" @click="goshopcar">Love</a></li>
                        </ul>
                      <img src="../assets/img/logo/header-logo.png" style="float: left;margin: 0 20px">
                        <ul style="float: left">
                        <li><a href="#">About</a></li>
                        <li ><a href="#">Signin</a>
                          <!--<div class="mega-menu">-->
                                                        <!--<span>-->
                                                            <!--<a href="shop-left-sidebar.html" class="title">Category</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Men's Colletion</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Women's Colletion</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Kid's Colletion</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Bag's Colletion</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Shoes Colletion</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Accessories</a>-->
                                                        <!--</span>-->
                            <!--<span>-->
                                                            <!--<a href="shop-left-sidebar.html" class="title">Brands</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Zara</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Walmart</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Arong</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Rong</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Velloci</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Dolce &amp; Gabbana</a>-->
                                                        <!--</span>-->
                            <!--<span>-->
                                                            <!--<a href="shop-left-sidebar.html" class="title">Materials</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Cotton</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Cotton Blends</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Lilen</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Polister</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Polister Blends</a>-->
                                                            <!--<a href="#"><i class="fa fa-circle"></i>Jeans</a>-->
                                                        <!--</span>-->
                            <!--<span>-->
                                                            <!--<img src="../assets/img/menu/1.jpg" alt="">-->
                                                        <!--</span>-->
                          <!--</div>-->
                        </li>
                        <li class="dropdown"><a href="shop.html">My cart</a>
                          <ul class="submenu-mainmenu">
                            <li><a href="">Cart</a></li>
                            <li><a href="checkout.html">Checkout</a></li>
                            <li><a href="shop-list.html">Shop List</a></li>
                            <li><router-link to="/orderlist" @click="goorderlist" style="cursor:pointer">orderlist</router-link></li>
                            <li><a href="shop-right-sidebar.html">Shop Right Sidebar</a></li>
                            <li><a href="shop-left-sidebar.html">Shop Left Sidebar</a></li>
                            <li><a href="product-details.html">Product Details</a></li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>
              </div>
              <!--<div class="col-lg-3 col-md-4 hidden-sm hidden-xs">-->
                <!--<div class="account-usd">-->
                  <!--<ul>-->
                    <!--<li><a href="account.html">My Account <i class="fa fa-angle-down"></i></a>-->
                      <!--<ul class="submenu-mainmenu">-->
                        <!--<li><router-link to='/login'><i class="fa fa-circle"></i>Login</router-link></li>-->
                        <!--<li><router-link to=""><i class="fa fa-circle"></i>My Account</router-link></li>-->
                        <!--<li><router-link to='/orderlist'><i class="fa fa-circle"></i>My Orderlist</router-link></li>-->
                        <!--<li><router-link to='/shopcar'><i class="fa fa-circle"></i>My Cart</router-link></li>-->
                        <!--<li><a href="checkout.html"><i class="fa fa-circle"></i>Checkout</a></li>-->
                      <!--</ul>-->
                    <!--</li>-->
                    <!--<li class="currency"><a href="#">USD <i class="fa fa-angle-down"></i></a>-->
                      <!--<ul class="submenu-mainmenu">-->
                        <!--<li><a href="#"><i class="fa fa-dollar"></i>USD</a></li>-->
                        <!--<li><a href="#"><i class="fa fa-euro"></i>EURO</a></li>-->
                        <!--<li><a href="#"><i class="fa fa-gbp"></i>GBP</a></li>-->
                      <!--</ul>-->
                    <!--</li>-->
                    <!--<li class="language"><a href="#"><img src="../assets/img/icon/eng.png" alt="">English <i class="fa fa-angle-down"></i></a>-->
                      <!--<ul class="submenu-mainmenu">-->
                        <!--<li><a href="#"><img src="../assets/img/icon/eng.jpg" alt="">English</a></li>-->
                        <!--<li><a href="#"><img src="../assets/img/icon/ger.jpg" alt="">German</a></li>-->
                        <!--<li><a href="#"><img src="../assets/img/icon/fren.jpg" alt="">French</a></li>-->
                      <!--</ul>-->
                    <!--</li>-->
                  <!--</ul>-->
                <!--</div>-->
              <!--</div>-->
            </div>
          </div>
        </div>
      </div>
      <!-- Mobile Menu Area start -->
      <div class="mobile-menu-area">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="mobile-menu">
                <nav id="dropdown">
                  <ul>
                    <li><a href="index.html">HOME</a>
                      <ul>
                        <li><a href="index-2.html">Home Version 2</a></li>
                      </ul>
                    </li>
                    <li><a href="about-us.html">
                        About
                    </a></li>
                    <li><a href="shop.html">Shop</a></li>
                    <li><a href="#">Men</a></li>
                    <li><a href="#">Women</a></li>
                    <li><a href="#">Accessories</a></li>
                    <li><a href="shop.htmll">Pages</a>
                      <ul>
                        <li><a href="cart.html">Cart</a></li>
                        <li><a href="checkout.html">Checkout</a></li>
                        <li><a href="shop-list.html">Shop List</a></li>
                        <li><router-link to="/orderlist" @click="goorderlist">orderlist</router-link></li>
                        <li><a href="shop-right-sidebar.html">Shop Right Sidebar</a></li>
                        <li><a href="shop-left-sidebar.html">Shop Left Sidebar</a></li>
                        <li><a href="product-details.html">Product Details</a></li>
                      </ul>
                    </li>
                    <li><a href="contact.html">Contact</a></li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      </header>
    </div>
</template>

<script>
import https from '../js/https.js'
export default {
  name: 'mcheader',
  data () {
    return {
      title: '巴拉多',
      shopcarList: [],
      total: 0,
      Shipping: 0,
      total1: 0
    }
  },
  methods: {
    getsecond () {
      var userid = sessionStorage.getItem('userId')
      $('nav#dropdown').meanmenu()
      https.fetchGet('mocalilie/api/shopcar/queryShopcar', {
        // 传递的参数
        userId: userid
      }).then((res) => {
        console.log(res.data.data)
        // 获取的参数
        this.shopcarList = res.data.data
        // 计算总价
        for (var i = 0; i < res.data.data.length; i++) {
          this.onetotal = (parseInt((res.data.data[i].price)) * parseInt((res.data.data[i].productCount))).toFixed(2)
          this.total = (parseInt(this.total) + parseInt(this.onetotal)).toFixed(2)
        }
        this.total1 = (parseInt(this.total) - parseInt(this.Shipping)).toFixed(2)
        console.log(this.onetotal)
      })
    },
    goshopcar () {

    },
    goorderlist () {
      this.$router.push({
        path: '/orderlist'
      })
    }
  },
  created () {
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mcheader.vue